import type { AdvertisingTypes } from "@litres-libs/types";

interface GetTopBannerPlacementArgs {
  isPDA: boolean;
  faceLanguage: string;
}

export const getTopBannerPlacement = ({
  isPDA,
  faceLanguage,
}: GetTopBannerPlacementArgs): {
  place: AdvertisingTypes.BannerPlaceSlugChoices;
} => {
  if (faceLanguage === "az") {
    return isPDA
      ? { place: "pda-header-full-width-az" }
      : { place: "web-header-full-width-az" };
  }
  if (faceLanguage === "uz") {
    return isPDA
      ? { place: "pda-header-full-width-uz" }
      : { place: "web-header-full-width-uz" };
  }
  return isPDA
    ? { place: "pda-header-full-width" }
    : { place: "web-header-full-width" };
};
